const noValueText = '\u2014';

// Formats a monitoring metric alongside the threshold it is judged against, e.g. "418 (10)". A metric
// with no threshold reported is shown on its own, and a metric that was not reported at all as a dash.
export default function formatMetricWithThreshold(metric, threshold) {
    if (metric == null) {
        return noValueText;
    }

    if (threshold == null) {
        return `${metric}`;
    }

    return `${metric} (${threshold})`;
}
